import React from 'react';
import useLogout from '@hooks/useLogout';
import { injectTestId } from '@cvent/nucleus-test-automation';
import { useTranslate } from 'nucleus-text';
import useBreakpoints from '@hooks/useBreakpoints';
import FullscreenModal from '@components/layout/FullscreenModal';
import { Row } from '@cvent/carina/components/Row';
import { Col } from '@cvent/carina/components/Col';
import Button from '@cvent/carina/components/Button';

const useStyles = isMobile => {
  return {
    content: {
      marginTop: isMobile ? '50%' : 0
    },
    body: {
      textAlign: 'center'
    }
  };
};

// Calls a window refresh when the auth token is no longer valid, presumably because it expired
// On refresh the regular auth flow will take over and redirect the user to the login page
export const ExpiredAuth = () => {
  const { translate } = useTranslate();
  const { isMobile } = useBreakpoints();
  const logout = useLogout();
  const styles = useStyles(isMobile);

  return (
    <FullscreenModal
      testID="expired-auth-error"
      disableFocusTrap
      content={
        <div css={styles.content}>
          <Row
            {...injectTestId('expired-auth-error-body')}
            justifyContent="center"
          >
            <Col>
              <p css={styles.body}>{translate('Login-Expired-Error-Body')}</p>
            </Col>
          </Row>
          <Row
            justifyContent="center"
            {...injectTestId('expired-auth-error-actions')}
          >
            <Col width="content">
              <Button
                testID="expired-auth-error-log-in-button"
                text={translate('Login-Expired-Error-Button')}
                appearance="filled"
                onClick={logout} // TODO: MAC-2974 is a partial fix to use the logout mechanism to prevent the login modal loop. The ideal solution still requires a spike and is explained in details in MAC-4103.
              />
            </Col>
          </Row>
        </div>
      }
    />
  );
};

export default ExpiredAuth;
